module.exports = __webpack_public_path__ + "img/premiere_page.baa8b2b4.png";